import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SharedService } from 'app/shared/services/shared.service';
import { SortService } from 'app/core/services/sort.service';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { BrokersService } from '../../services/brokers.service';
import { BrokersModel } from 'app/brokers/models/brokers.model';
import { debounceTime } from 'rxjs/operators';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';

@Component({
    selector: 'app-brokers',
    templateUrl: './brokers-list.component.html',
    styleUrls: ['./brokers-list.component.css']
})
export class BrokersListComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    brokers: BrokersModel[];
    brokersList: BrokersModel[];
    filterForm: FormGroup;
    filterTextControl: FormControl;
    lastSort: ColumnSortedEvent;
    selectedBrokerId: string;

    constructor(
        private _router: Router,
        private brokersService: BrokersService,
        private fb: FormBuilder,
        private sortService: SortService,
        private sharedService: SharedService
    ) { }

    ngOnInit() {
        this.headerTitle = { title: 'Brokers' }
        this.load();
    }

    load() {
        this.brokersService.getAll().subscribe(
            brokers => {
                this.brokers = brokers;
                this.brokersList = brokers;
            },
            error => this.errors = error.errorList
        );

        this.filterTextControl = this.fb.control('');
        this.filterForm = this.fb.group({
            filterText: this.filterTextControl
        });

        this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
            this.brokersList = this.sortService.filterAndSortlist(this.brokers, newValue, this.lastSort);
        });
    }

    deleteBroker() {
        this.brokersService.deleteBroker(this.selectedBrokerId).subscribe(
            result => this.load(),
            error => console.log(error)
        );
    }

}
